/** Parse directory_details from API (string or array). */
export const parseDirectoryDetails = (directoryDetails) => {
  if (!directoryDetails) return [];
  try {
    const parsed =
      typeof directoryDetails === "string"
        ? JSON.parse(directoryDetails)
        : directoryDetails;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/** Current folder id from breadcrumb; 0 = Home/root. */
export const getCurrentFolderIdFromNavPath = (navPath) => {
  const last = navPath?.[navPath.length - 1];
  if (!last || last.name === "Home" || last.id === 0) return 0;
  return last.id;
};

export const isAtDocumentHome = (navPath) =>
  navPath?.length === 1 && navPath?.[0]?.id === 0;

/**
 * Whether a file row belongs in the listing for the current folder (not parent/child).
 */
export const fileBelongsToCurrentFolder = (file, navPath) => {
  if (!file) return false;

  const currentFolderId = getCurrentFolderIdFromNavPath(navPath);
  const docFolderId = file.client_folder_id ?? file.folder_id ?? null;

  if (currentFolderId === 0) {
    if (
      docFolderId != null &&
      docFolderId !== 0 &&
      docFolderId !== "0" &&
      docFolderId !== ""
    ) {
      return false;
    }
    const details = parseDirectoryDetails(file.directory_details);
    if (details.length > 1) return false;
    return true;
  }

  if (docFolderId != null && docFolderId !== "") {
    return String(docFolderId) === String(currentFolderId);
  }

  const details = parseDirectoryDetails(file.directory_details);
  const last = details[details.length - 1];
  return (
    last &&
    (String(last.id) === String(currentFolderId) ||
      String(last.name) === String(navPath[navPath.length - 1]?.name))
  );
};
